import {
  getMFSDetailsAPI,
  addMFSDetailsAPI,
  updateMFSDetailsAPI,
  deleteMFSDetailsAPI
} from '../adapter/adapter'

export function getAllMFSHelper() {
  let promise = new Promise(function (resolve, reject) {
    getMFSDetailsAPI()
      .then((res) => {
        console.log('getAllMFSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get MFS Failure')
        }
      })
      .catch((err) => {
        console.log('getAllMFSHelper err: ', err)
        reject('Get MFS Failure')
      })
  })

  return promise
}

export function addMFSHelper(data) {
  let reqData = {
    mfs_name: data.mfs_name,
    mfs_account_name: data.mfs_account_name,
    account_number: data.account_number,
    payment_receiver_bank_id: data.payment_receiver_bank_id,
    transaction_charge: data.transaction_charge
  }

  let promise = new Promise(function (resolve, reject) {
    addMFSDetailsAPI(reqData)
      .then((res) => {
        console.log('addMFSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add MFS Failure')
        }
      })
      .catch((err) => {
        console.log('addMFSHelper err: ', err)
        reject('Add MFS Failure')
      })
  })

  return promise
}

export function updateMFSHelper(data) {
  let reqData = {
    id: data.id,
    mfs_name: data.mfs_name,
    mfs_account_name: data.mfs_account_name,
    account_number: data.account_number,
    payment_receiver_bank_id: data.payment_receiver_bank_id,
    transaction_charge: data.transaction_charge
  }

  let promise = new Promise(function (resolve, reject) {
    updateMFSDetailsAPI(reqData)
      .then((res) => {
        console.log('updateMFSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update MFS Failure')
        }
      })
      .catch((err) => {
        console.log('updateMFSHelper err: ', err)
        reject('Update MFS Failure')
      })
  })

  return promise
}

export function deleteMFSHelper(id) {
  let reqData = {
    id: id
  }

  let promise = new Promise(function (resolve, reject) {
    deleteMFSDetailsAPI(reqData)
      .then((res) => {
        console.log('deleteMFSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.code === 200) {
          resolve(true)
        } else {
          reject('Delete MFS Failure')
        }
      })
      .catch((err) => {
        console.log('deleteMFSHelper err: ', err)
        reject('Delete MFS Failure')
      })
  })

  return promise
}

